import React, { FC } from 'react';
import { Select } from 'antd';
import { useTranslation } from 'react-i18next';
import { Field } from 'formik';
import { SelectValue } from 'antd/lib/select';

import ua from 'locales/ua/translation.json';
import { StyledSelect, StyledSelectWithLabel, StyledLabel } from './style';

interface SelectUserStatusProps {
  name: string;
  onChange: (value: SelectValue) => void;
  value?: any;
}

const { Option } = Select;
const Roles = ['SYSTEM_ADMIN', 'ADMIN', 'SYSTEM_USER', 'USER'];
export const SelectRole: FC<SelectUserStatusProps> = ({ name, value, onChange }) => {
  const { t } = useTranslation();

  return (
    <StyledSelectWithLabel>
      <StyledLabel>{t('infoFields.role')}</StyledLabel>
      <Field as={StyledSelect} name={name} style={{ width: '100%' }} defaultValue={value} onChange={onChange}>
        {Roles.map((role) => (
          <Option key={`user-group-${role}`} value={role}>
            {t(`userGroup.role.${role}` as any)}
          </Option>
        ))}
      </Field>
    </StyledSelectWithLabel>
  );
};
